import request from 'utils/request';
import { CourierCallPost } from './types/CourierCallPost';

export function courierCallPost(data: CourierCallPost): Promise<unknown> {
    return request({
        url: '/call-courier',
        method: 'POST',
        data,
    });
}
